/* topology.js */

"use strict";

module.exports = {
    name: "topology",
    label: "Topology",
    title: "Topology",
    disabled: false,
    order: 15, // Deprecated -- Newer solution uses order from index.js
    app: "GameConsole",
    section: "frontend",
    license: ["GLUWARE", "TOP"],
    accessPerm: ["topologyAccess"],
    pageTitle: "Topology",
    helpLink: "Topology/Topology-overview.htm",
    iconName: "topology.solution",
    navIcon: "topology.solution",
};
